import axiosPost from '../axiosPost';
import { AxiosPostBody } from '../../../types/AxiosPost';
import { UserCredentialsType } from '../../../types/types';

type Args = UserCredentialsType & {
    "posTransaccionUUID": string
};

export const MerchantCobroMovimientoGet = async (arg: Args) => {
    const body: AxiosPostBody = {
        "service": "MerchantCobroMovimientoGet",
        "params": {
            "posTransaccionUUID": arg.posTransaccionUUID,
        }
    };

    try {
        const result = await axiosPost('Y', body, arg);

        return result.result
    } catch (err) {
        console.log(err)
    }
}